export enum AutoResolvedRowState {
  ACTIVE = 'active',
  UNDONE = 'undone',
  CONFIRMED = 'confirmed',
}
